<!--
    Component Name: SingleMembershipEditor
    Summary:
    Properties:
-->
<template>
    <div class="LivingSituationEditor">
        <div>

            <b-row style="overflow-x:auto;">
                <b-col cols="11">
                    <vuetable :fields="Fields"
                                :data="SituationData"
                                pagination-path=""
                                :api-mode="false"
                                class="vue-datatable"
                                row-class="bold-first-row">
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode && CheckPermission('Wraparound.LivingSituations.Edit')" class="vert-icons">
                        <b-row v-if="TableState == 'NoRecords'">
                            <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddRecord()" class="pointer olive-green-text" />
                        </b-row>
                        <b-row v-if="TableState == 'OneOpen'">
                            <font-awesome-icon :icon="['fas', 'exchange-alt']" v-on:click="ShowTransferRecord()" class="pointer olive-green-text" />
                        </b-row>
                        <b-row v-if="TableState == 'OneOpen'">
                            <font-awesome-icon :icon="['fas', 'trash-alt']" v-on:click="ShowDeleteRecord()" class="pointer red" />
                        </b-row>
                    </div>
                </b-col>
            </b-row>


            <!--ADD NEW RECORD MODAL-->
            <b-modal ref="add-modal" title="Living Situation at Referral" hide-footer>
                <b-container>
                    <b-form @submit="AddRecord">
                        <b-row>
                            <b-col>
                                <h5 class="center-text">Living Situation Details</h5>
                                <div class="form-group">
                                    <label>Situation Type:</label>
                                    <select class="form-control" v-model="NewSituation.SituationType" required>
                                        <option value=""></option>
                                        <option value="Family / Relative Home">Family / Relative Home</option>
                                        <option value="Foster Home">Foster Home</option>
                                        <option v-if="!IsIls" value="Group Home / Residential Care">Group Home / Residential Care</option>
                                        <option value="Hospital">Hospital</option>
                                        <option v-if="!IsIls" value="Juvenile Detention Facility">Juvenile Detention Facility</option>
                                        <option value="Homeless">Homeless</option>
                                        <option v-if="IsIls" value="Youth Housing Assistance">Youth Housing Assistance</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Informal Description:</label>
                                    <input type="text" class="form-control" v-model="NewSituation.InformalDescription" required placeholder="ex: Maternal Grandmother"/>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5 class="center-text">Address</h5>
                                <div class="form-group">
                                    <label>Address Line 1:</label>
                                    <input type="text" class="form-control" v-model="NewSituation.AddressLine1" required />
                                </div>
                                <div class="form-group">
                                    <label>Address Line 2:</label>
                                    <input type="text" class="form-control" v-model="NewSituation.AddressLine2" />
                                </div>
                                <div class="form-group">
                                    <label>City:</label>
                                    <input type="text" class="form-control" v-model="NewSituation.City" required />
                                </div>
                                <div class="form-group">
                                    <label>State:</label>
                                    <select class="form-control" v-model="NewSituation.StateAbbreviation" required>
                                        <option v-for="option in StateOptions" v-bind:value="option.value">{{ option.text }}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Zip Code:</label>
                                    <input type="number" class="form-control" v-model="NewSituation.ZipCode" required />
                                </div>
                                <div class="form-group">
                                    <label>County:</label>
                                    <v-select :options="CountyOptions" label="text" :reduce="option => option.value" v-model="NewSituation.County" required></v-select>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="CancelAddRecord()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="success" type="submit">
                                    SAVE
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>

            <!--TRANSFER RECORD MODAL-->
            <b-modal ref="transfer-modal" title="Transfer Living Situation" hide-footer>
                <b-container>
                    <b-form @submit="TransferRecord">
                        <b-row>
                            <b-col>
                                <h5 class="center-text">Living Situation Details</h5>
                                <div class="form-group">
                                    <label>Situation Type:</label>
                                    <select class="form-control" v-model="NewSituation.SituationType" required>
                                        <option value=""></option>
                                        <option value="Family / Relative Home">Family / Relative Home</option>
                                        <option value="Foster Home">Foster Home</option>
                                        <option v-if="!IsIls" value="Group Home / Residential Care">Group Home / Residential Care</option>
                                        <option value="Hospital">Hospital</option>
                                        <option v-if="!IsIls" value="Juvenile Detention Facility">Juvenile Detention Facility</option>
                                        <option value="Homeless">Homeless</option>
                                        <option v-if="IsIls" value="Youth Housing Assistance">Youth Housing Assistance</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Informal Description:</label>
                                    <input type="text" class="form-control" v-model="NewSituation.InformalDescription" required placeholder="ex: Maternal Grandmother" />
                                </div>
                                <div class="form-group">
                                    <label>Date New Living Situation Began:</label>
                                    <flat-pickr v-model="NewSituation.EffectiveDate" class="form-control" required :config="DateConfig"></flat-pickr>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h5 class="center-text">Address</h5>
                                <div class="form-group">
                                    <label>Address Line 1:</label>
                                    <input type="text" class="form-control" v-model="NewSituation.AddressLine1" required />
                                </div>
                                <div class="form-group">
                                    <label>Address Line 2:</label>
                                    <input type="text" class="form-control" v-model="NewSituation.AddressLine2" />
                                </div>
                                <div class="form-group">
                                    <label>City:</label>
                                    <input type="text" class="form-control" v-model="NewSituation.City" required />
                                </div>
                                <div class="form-group">
                                    <label>State:</label>
                                    <select class="form-control" v-model="NewSituation.StateAbbreviation" required>
                                        <option v-for="option in StateOptions" v-bind:value="option.value">{{ option.text }}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Zip Code:</label>
                                    <input type="number" class="form-control" v-model="NewSituation.ZipCode" required />
                                </div>
                                <div class="form-group">
                                    <label>County:</label>
                                    <v-select :options="CountyOptions" label="text" :reduce="option => option.value" v-model="NewSituation.County" required></v-select>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="CancelTransferRecord()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="success" type="submit">
                                    SAVE
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>

            <!--DELETE CURRENT RECORD MODAL-->
            <b-modal ref="delete-modal" title="Remove Current Living Situation" hide-footer>
                <b-container>
                    <b-form @submit="DeleteRecord">
                        <b-row>
                            <b-col>
                                <p>You are about to remove the current Living Situation for this client.  If there was a previous living situation, it will re-open that situation.</p>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="CancelDeleteRecord()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="danger" type="submit">
                                    DELETE
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>
        </div>
        <div v-else>
            PRIVATE
        </div>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faExchangeAlt);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);

    //import components
    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    import { EventBus } from '../../../services/event-bus.js';

    export default {
        props: [
            "SituationData",
            "EditMode",
            "ChartId",
            "IsIls"//bool
        ],
        data: function () {
            return {
                NewSituation: {},
                SituationSchema: {
                    "AddressLine1": "",
                    "AddressLine2": "",
                    "City": "",
                    "StateAbbreviation": "",
                    "ZipCode": "",
                    "County": "",
                    "SituationType": "",
                    "InformalDescription": "",
                    "EffectiveDate": ""
                },
                Fields: [
                    {
                        name: 'Address.AddressSingleLine',
                        title: 'LOCATION'
                    },
                    {
                        name: 'SituationType',
                        title: 'TYPE'
                    },
                    {
                        name: 'InformalDescription',
                        title: 'DESCRIPTION'
                    },
                    {
                        name: 'StartDate',
                        title: 'STARTED',
                        callback: 'formatDate|MM/DD/YY'
                    },
                    {
                        name: 'EndDate',
                        title: 'ENDED',
                        callback: 'formatDate|MM/DD/YY|N/A'
                    }
                ],
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                },
            };
        },
        methods: {
            //ADD RECORD
            ShowAddRecord() {
                this.NewSituation = JSON.parse(JSON.stringify(this.SituationSchema));
                this.$refs['add-modal'].show();
            },
            AddRecord(e) {
                e.preventDefault();
                this.NewSituation.ClientSubProgramMembershipID = this.ChartId;
                this.$MasterAPI.ExecuteRequest("POST", "Wraparound/LivingSituations/AddFirstLivingSituation", this.NewSituation, this.AddRecordSuccess, () => { }, true);
            },
            AddRecordSuccess(response) {
                let vm = this;
                vm.$refs['add-modal'].hide();
                //Perform Global Updates
                vm.$GlobalUpdate.ExecuteGlobalUpdate(vm.ChartId);
            },
            CancelAddRecord() {
                this.$refs['add-modal'].hide();
            },
            //TRANSFER RECORD
            ShowTransferRecord() {
                this.NewSituation = JSON.parse(JSON.stringify(this.SituationSchema));
                this.$refs['transfer-modal'].show();
            },
            TransferRecord(e) {
                e.preventDefault();
                this.NewSituation.ClientSubProgramMembershipID = this.ChartId;
                this.$MasterAPI.ExecuteRequest("POST", "Wraparound/LivingSituations/TransferLivingSituation", this.NewSituation, this.TransferRecordSuccess, () => { }, true);
            },
            TransferRecordSuccess(response) {
                let vm = this;
                vm.$refs['transfer-modal'].hide();
                //Perform Global Updates
                vm.$GlobalUpdate.ExecuteGlobalUpdate(vm.ChartId);
            },
            CancelTransferRecord() {
                this.$refs['transfer-modal'].hide();
            },
            //DELETE RECORD
            ShowDeleteRecord() {
                this.$refs['delete-modal'].show();
            },
            DeleteRecord(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Wraparound/LivingSituations/DeleteLivingSituation", { Id: this.ChartId }, this.DeleteRecordSuccess, () => { }, true);
            },
            DeleteRecordSuccess(response) {
                let vm = this;
                vm.$refs['delete-modal'].hide();
                //Perform Global Updates
                vm.$GlobalUpdate.ExecuteGlobalUpdate(vm.ChartId);
            },
            CancelDeleteRecord() {
                this.$refs['delete-modal'].hide();
            },

            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            formatDate (value, fmt = 'D MMM YYYY', defaultValue='') {
              return (value == null)
                ? defaultValue
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
        },
        components: {
            Vuetable,
            flatPickr,
            vSelect
        },
        computed: {
            ModalTitle: function () {
                return "Editing " + this.DataLabel;
            },
            TableState: function () {
                if (this.SituationData.length == 0) {
                    return "NoRecords";
                } else if (this.SituationData.filter(datalist => datalist.EndDate == null).length == 0) {
                    return "AllClosed";
                } else {
                    return "OneOpen";
                }
            },
            StateOptions: function () {
                return this.$store.state.Options.USStateAbbreviations;
            },
            CountyOptions: function () {
                return this.$store.state.Options.CaliforniaCounties;
            }
        }
    }
</script>

<style scoped>
    .vert-icons div {
        margin-top:10px;
    }
    /deep/ tbody tr:first-child {
        font-weight: bold;
    }
    table {
        table-layout:auto;
    }
    .vue-datatable {
        width: 100%;
        display: inline-table;
        overflow-x: auto;
    }
</style>